import { useEffect, useState } from 'react'

import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import { cachePhotos } from '../function/cachePhotos'
import { mergePhotos } from '../function/mergePhotos'

export const useCacheVotedPhotos = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const { votedPhotos = [] } = useShallowEqualSelector(
    ({ photoRatingNext: { votedPhotos } }) => ({
      votedPhotos,
    })
  )

  useEffect(() => {
    if (votedPhotos.length > 0 && !loading) {
      setLoading(true)
      const _photos = [...votedPhotos]
        .map((item) =>
          mergePhotos(
            item.photo,
            item.extraPhotos,
            item.photoOwner.photos.photos.nodes
          )
        )
        .map((item) => item[0])

      cachePhotos(_photos.flat())
    }
  }, [loading, votedPhotos])
}
